import styled from 'styled-components';

export const StyledDeleted = styled.section`
  ${({ theme }) => theme.mixins.views}
`;
